export const m = {
  EnterID: "Tada ID'yi girmek için tıklayın",
  "select-specifications":
    "Para yatırma teknik özelliklerini seçmek için tıklayın",
  "check-account": "Para yatırma teknik özelliklerini seçmek için tıklayın",
  whatID: "Tada Kimliği nedir?",
  getID: "Tada Kimliğini Girin",
  maskgetID: "Tada Kimliğini Girin",

  "toastTips-format-error": "Giriş biçimi yanlış",
  "toastTips-no-exist": "Kimlik yok",
  toastTipsPlease: "Lütfen önce para yatırma hesabını kontrol edin",
  "transaction-succeeded": "İşlem başarılı oldu",
  PayStatusSuccess_title: "İşlem başarılı oldu",
  "transaction-failed": "Hareket başarısız oldu",
  PayStatusFail_title: "Hareket başarısız oldu",
  "transaction-cancel": "İşlem iptal edildi",
  PayStatusCancel_title: "İşlem iptal edildi",
  "buy-notice-a": "Not: <a>pay.tadachat.info</a> Tada için tek resmi elmas satın alma web sitesi",
  replace: "Değiştirmek",
  Diamonds_title: "Tada Elmas Yatırma Resmi Web Sitesi",
  openAPP: "Tada APP'i aç",
  description: `Tada sadece resmi elmas yatırma sitesi, Tada uluslararası bir sosyal yazılım, 150'den fazla ülke ve dünya çapında bölgeler Tada kullanıyorsunuz`,
  keywords:
    "Tada Para yatırma, Tada elmas yatırma, Tada resmi para yatırma, Tada resmi para yatırma web sitesi",
  wxPay: "WeChat ödemesinin tamamlandığını lütfen onaylayın",
  failedPay: "Ödeme ile ilgili bir sorun var ve tekrar ödeme",
  Completed: "Ödeme tamamlandı",
  "toastTips-no-complete": "Ödeme tamamlanmadı, lütfen tekrar ödeyin",

  RechargeHelp_title: "Para yatırma yardemi",
  "buy-enter-link":
    "Satın alma elmas bağlantı üzerinden şarj edilebilir, https://pay.Tadachat.info Açmak için mobil tarayıcıda bağlantıyı kopyalayın, hesap kontrol ettikten sonra, satın alma sayfasına girin, ilgili özellikleri seçin ve indirimler ~ Çok ödemek için uygun ödeme yöntemini kullanın!",
  "buy-diamonds-tit": "Satın alma Elmas Servisi",
  "buy-notice":
    "Not pay.Tadachat.info Tada tek resmi elmas satın alma web sitesi, müşteri hizmetleri sorgulamaiçin, lütfen [Mesaj]-[Resmi Haberler]-[Geribildirim ve Yardım] girin",
  "common-problem": "Sık karşılaşılan sorunlar",
  rechargeFAQ_title: "Sık karşılaşılan sorunlar",

  "whether-account":
    "Para yatırdıktan sonra hesabın alınıp alınmadığını nasıl kontrol edebilirim?",
  "answer-whether-account": `Para yatırdıktan sonra, elmasları görüntülemek için uygulamanın [Benim]-[Cüzdan] kısmından bakabilirsiniz.`,
  "no-account": "Para yatırdıktan sonra hesabı alamazsam ne olur?",
  "answer-no-account":
    "Lütfen sorularınızı APP'in [Mesaj]-[Resmi Haberler]-[Geri Bildirim ve Yardım] adresine gönderin ve aşağıdaki bilgileri sağlayın, müşteri hizmetlerimiz size yardımcı olacaktır.",
  "recharge-money": "1. Yatırılan tutarı ve hesap kimliği",
  "recharge-time": "2. Para yatırma saati ve tarihi",
  "recharge-shot": "3. Başarılı ödeme ekran görüntüsü",
  "recharge-wrong":
    "Yanlış hesap ve yanlış tutardan ücret alırsam ne yapmalıyım?",
  "answer-recharge-wrong": `Ödeme şifresini girmeden önce, satın alma işlemi yapmak için lütfen yükleme hesabı kimliğini ve yükleme tutarı bilgilerini dikkatlice doğruladığınızdan emin olun. Yanlış yüklenen miktar iade edilemez. Yanlış ödeme hesabı için, gerçekten yükleme yaptığınız kimlik kullanıcısıyla iletişime geçmeyi deneyebilir ve yüklemenizi tazmin etmek isteyip istemediklerini diğer tarafla görüşebilirsiniz.`,
  refund: "Iade",
  "answer-refund":
    "Üzgünüm! Tada şu anda herhangi bir geri ödeme biçimini desteklememektedir.",
  sureBtn: "	Onaylamak",
  "pay-style": "	Ödeme yöntemini seçin",
  goBack: "	Ana sayfaya dön",
  toastTips: "	Tada Kimliğini Girin",
  "payforType": "Yükleme yöntemi",
  trueText: "Onaylamak",
  falseText: "İptal",
  alertShowTxt1: "kullanacağınızdan  emin misiniz",
  alertShowTxt3: "yüklemek",
  alertShowTxt5: "elmasları ?",
  EnterIDTip: "Tada hızlı yükleme",
  scanLogin:
    "Hesap gizliliği ve güvenliği için lütfen giriş yapmak için kodu tarayın",
  scanTip:
    'İpucu: Oturum açmak için kodu taramak üzere Tada "Kişisel Merkez / Dinamikler" in sağ üst köşesindeki "Tara" düğmesine tıklayın. Aynı zamanda, QR kodu ekran görüntüsünü tanımlayarak oturum açmayı destekler',
  scanVersion:
    "Lütfen Tada'I %s sürümüne yükseltin ve oturum açmak için kodu tarayın",
  delAccount: "Hesap silme",
  logout: "Oturum aç",
  submit: "Submit",
  email_place_holder: "Please enter your email address",
  contact_email: "Contact E-mail",
  provide_email: "Please provide your E-maii address for payment order",
  email_address: "E-mail Addrerss",
  reseller: "Bayi",
};



// WEBPACK FOOTER //
// ./src/lang/tr.js